import styles from "./ProfileTitle.module.css";
import cn from "classnames";

// Components
import Row from "gui/layout/row";
import { ButtonOld } from "components/ButtonOld/ButtonOld";
import { Icon } from "gui/icon/icon";

// State
import { useSession, useSessionHasPaidPlan } from "gui/session/session";
import { emojiMapping, formattedPlanName } from "lib/plans/plans";
import Emoji from "gui/emoji";

export interface Props {
  sectionId: string;
  userId: number;
  title: string;
  serviceTierName: string;
  className?: string;
}

export default function ProfileTitle(props: Props) {
  const session = useSession();
  const isEditable = session?.user?.id === props.userId;
  const hasPaidPlan = useSessionHasPaidPlan();
  const className = cn(styles.title);

  return (
    <Row
      layout="center-aligned"
      gap={props.serviceTierName ? "small" : "normal"}
      className={props.className}
    >
      <h1 className={className} id={props.sectionId}>
        {props.title}
      </h1>

      {(props.serviceTierName !== "" || isEditable) && (
        <Row>
          {props.serviceTierName !== "" && hasPaidPlan && (
            <ButtonOld
              size="sm"
              color2
              light
              href={isEditable ? "/settings/subscription" : undefined}
              disabled={!isEditable}
            >
              <Emoji
                name={emojiMapping(props.serviceTierName)}
                width="1.5rem"
              />
              {formattedPlanName(props.serviceTierName)}
            </ButtonOld>
          )}
          {isEditable && (
            <>
              <EditProfileButton />
              {!hasPaidPlan && (
                <ButtonOld href="/pricing" size="sm" color2 light>
                  Upgrade
                </ButtonOld>
              )}
            </>
          )}
        </Row>
      )}
    </Row>
  );
}

function EditProfileButton() {
  return (
    <>
      <ButtonOld href="/settings/profile" size="sm">
        <Row gap="small">
          <span>Edit</span>
          <Icon className={styles["button-icon"]} icon={"edit"}></Icon>
        </Row>
      </ButtonOld>
    </>
  );
}
